/* istanbul ignore file */
const defaultTranslations = {
  duration: 'Duration',
  releaseDateOpening: 'Opening on',
  releaseSpring: (year) => `Coming in<br />spring ${year}`,
  releaseSummer: (year) => `Coming in<br />summer ${year}`,
  releaseFall: (year) => `Coming in<br />fall ${year}`,
  releaseWinter: (year) => `Coming in<br />winter ${year}`,
  durationMonths: (count) => (count === 1 ? '~ 1 month' : `~ ${count} months`),
  durationHours: (count) => (count === 1 ? '1 hour' : `${count} hours`),
  durationMinutes: (count) => (count === 1 ? '1 minute' : `${count} minutes`),
  durationFullTimeMonths: (count) =>
    count === 1 ? 'Full time : 1 month' : `Full time : ${count} months`,
};

export default defaultTranslations;
